import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  padding-bottom: 8px;
  align-items: center;
  gap: 24px;
  row-gap: 8px;
`

const FilterPanel = ({ children, dataTest, className }) => {
  return (
    <StyledWrapper
      data-test={dataTest}
      className={className}
    >
      {children}
    </StyledWrapper>
  )
}

FilterPanel.propTypes = {
  children: PropTypes.node,
  dataTest: PropTypes.string,
}

export default FilterPanel
